import AOS from 'aos';
import { debounce } from 'underscore'; // https://underscorejs.org
import { ScrollHandler } from './includes/scroll-handler';
// import { CookieHelper } from './includes/cookies';
import 'slick-slider';
import { Collapse } from 'bootstrap';
import Scrollspy from 'bootstrap/js/dist/scrollspy.js';


jQuery(function ($) {
    'use strict';

    // cache body selectors
    const $htmlBody = $('html, body'); // html & body selector (for menu functions)
    const $body     = $('body'); // body only selector

    // FADE IN CONTENT ON PAGE LOAD
    setTimeout(function () {
        $body.addClass('delayfade');
    }, 200);

    /***************************************************************/
    /************************* STICKY HEADER ***********************/
    /***************************************************************/

    const header = document.querySelector('#masthead');
    const topBar = document.querySelector('#sticky-nav-spacer');
    const bottomBar = document.querySelector('.logo-main-nav');

    // Function to handle layout
    function makeLayout() {
        document.documentElement.style.setProperty(
            '--nav-height',
            `${header.offsetHeight + header.offsetTop}px`
        );
        if (topBar) {
            document.documentElement.style.setProperty('--top-bar-height', `${topBar.offsetHeight}px`);
        }
        if (bottomBar) {
            document.documentElement.style.setProperty('--bottom-bar-height', `${bottomBar.offsetHeight}px`);
        }
    }

    // Function to handle sticky bottom bar
    function makeSticky() {
        if (!bottomBar) return;

        const bottomBarRect = bottomBar.getBoundingClientRect();
        const topBarRect = topBar ? topBar.getBoundingClientRect() : null;

        if (bottomBarRect.bottom <= -200) {
            document.body.classList.add('sticky-bottom-bar');
        }

        let topBarHeight = 0
        if( document.querySelector('.alert-bar') ) {
            topBarHeight = document.querySelector('.alert-bar').offsetHeight;
            if (topBarRect && topBarRect.bottom >= topBarHeight) {
                document.body.classList.remove('sticky-bottom-bar');
            }
        } else {
            if (topBarRect.top >= topBarHeight) {
                document.body.classList.remove('sticky-bottom-bar');
            }
        }

    }

    // Set layout event bindings
    function setLayoutEventBindings() {
        window.addEventListener('load', makeLayout);
        window.addEventListener('resize', makeLayout);
    }

    // Set sticky event bindings
    function setStickyEventBindings() {
        window.addEventListener('load', makeSticky);
        window.addEventListener('resize', makeSticky);
        window.addEventListener('scroll', makeSticky);
    }


    makeLayout();
    makeSticky();
    setLayoutEventBindings();
    setStickyEventBindings();

    /*********************** END STICKY HEADER **********************/


    /***************************************************************/
    /************************* ALERT BAR HOVER ***********************/
    /***************************************************************/

    const alertBar = document.querySelector('.alert-bar');
    const alertBarLinks = document.querySelectorAll('.alert-bar a');

    if (alertBar && alertBarLinks.length) {
        alertBarLinks.forEach(link => {
            link.addEventListener('mouseover', () => {
                alertBar.classList.add('hover');
            });

            link.addEventListener('mouseout', () => {
                alertBar.classList.remove('hover');
            });
        });
    }


    /*********************** END ALERT BAR HOVER **********************/


    /***************************************************************/
    /************************* STICKY SIDEBAR ***********************/
    /***************************************************************/

    /// PRACTICE AREA STICKY & SCROLLSPY
    let scrollLinks = $('#scrollspy-anchor-links');
    let scrollLink = $('#scrollspy-anchor-links a');
    let alToggle = $('#al-toggle');

    $(window).on('load', function() {
        if( $(scrollLinks).length ) {
            $('body').scrollspy({ target: scrollLinks });
        }
    });

    /*********************** END STICKY SIDEBAR **********************/



    /***************************************************************/
    /********************** MENU FUNCTIONALITY *********************/
    /***************************************************************/

    const $submenus = document.querySelectorAll('#mobile-menu #menu-main-navigation li.menu-item-has-children .sub-menu');
    let submenu_index = 1; // assuming this is declared somewhere earlier in the script

    $submenus.forEach(function ($submenu) {
        const subMenuParent = $submenu.parentNode;
        $submenu.classList.add('collapse');
        $submenu.id = 'submenu-' + submenu_index;

        let $toggle;

        // Check if the parent link has an href="#"
        const parentLink = subMenuParent.querySelector('a');

        if (parentLink && parentLink.getAttribute('href') === '#') {
            $toggle = parentLink; // Use the link itself as the toggle if its href is '#'
            $toggle.href = `#${$submenu.id}`; // Modify its href to target the submenu
        } else {
            // Create a new button element for the toggle
            const toggleBtn = document.createElement('button');
            toggleBtn.innerHTML = '<svg width="15" height="9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.196 8.695a.935.935 0 0 1-1.382 0L.287 1.775a1.079 1.079 0 0 1 0-1.466.939.939 0 0 1 1.382 0L7.5 6.494l5.833-6.19a.935.935 0 0 1 1.382 0c.38.407.383 1.065 0 1.467L8.196 8.695Z" fill="#000"/></svg>'; // Optionally set button text
            $toggle = toggleBtn;

            $toggle.dataset.bsTarget = '#submenu-' + submenu_index;
            $toggle.setAttribute('aria-controls', 'submenu-' + submenu_index);

            // Insert the button after the parent link
            parentLink.insertAdjacentElement('afterend', toggleBtn);
        }

        // Add required classes and attributes to the toggle
        $toggle.classList.add('collapsed');
        $toggle.dataset.bsToggle = 'collapse';
        $toggle.role = 'button';
        $toggle.ariaExpanded = 'false';
        $toggle.ariaControls = $submenu.id;

        submenu_index += 1;
    });


//     for (const $submenu of $submenus) {
//         $submenu.classList.add('collapse');
//         $submenu.id = `mainSubmenuCollapse${submenu_index}`;
//         // Uncomment code below to collapse other submenus.
//         $submenu.dataset.bsParent = `#${this.selectors.menu}`;
//
//         const $toggle = $submenu.previousElementSibling;
//
//         $toggle.classList.add('collapsed');
//         $toggle.dataset.bsToggle = 'collapse';
//         $toggle.href = `#${$submenu.id}`;
//         $toggle.role = 'button';
//         $toggle.ariaExpanded = 'false';
//         $toggle.ariaControls = $submenu.id;
//
//         submenu_index += 1;
//     }

    // const $navDropToggle        = $('#navDropToggle'); // set mobile nav trigger
    const mobileBreakPoint      = 1199; // make sure sass var is set the same
    const $mobileTrigger        = $('header .mobile-toggle');
    const $mobileMenu            = $('header #mobile-menu');
    let navState                = null;

    // check/set nav state (mobile/desktop)
    function setNavState() {

        if( $(window).width() > mobileBreakPoint ) {

            navState = 'desktop';
            $mobileTrigger.removeClass('is-active');
            $mobileTrigger.attr('aria-expanded', 'false');
            $mobileMenu.fadeOut(300);
            $mobileMenu.attr('aria-hidden', 'true');
            $htmlBody.removeClass('mobile-nav-open');

        } else {

            navState = 'mobile';

        }

    }
    // store debounced version to use when window is resized (bottom of file)
    const dbc_SetNavState = debounce(setNavState, 100);

    $mobileTrigger.on('click', function(e) {

        if( ! $(e.currentTarget).hasClass('is-active') ) {

            $(e.currentTarget).addClass('is-active');
            $(e.currentTarget).attr('aria-expanded', 'true');
            $mobileMenu.attr('aria-hidden', 'false');
            $htmlBody.addClass('mobile-nav-open');
            $($mobileMenu).fadeIn(300);

        } else {

            $(e.currentTarget).removeClass('is-active');
            $(e.currentTarget).attr('aria-expanded', 'false');
            $mobileMenu.attr('aria-hidden', 'true');
            $htmlBody.removeClass('mobile-nav-open');
            $mobileMenu.fadeOut(300);

        }
    });

    // init NavState on page load
    dbc_SetNavState();
    /********************** END MENU FUNCTIONALITY ******************/


    /***************************************************************/
    /*********************** SCROLL FUNCTIONS **********************/
    /***************************************************************/
    // const valFixedHeader        = 101;

    // const headerScroll = {
    //     selectors: {
    //         body: 'body'
    //     },

    //     config: {
    //         fixedHeader:    valFixedHeader
    //     },

    //     cache: {
    //         $body: null
    //     },

    //     init: function() {
    //         this.cache.$body = $(this.selectors.body);
    //         ScrollHandler.addCallback(this.onScroll, true);
    //     },

    //     onScroll: function(scrollY) {
    //         if( navState == 'desktop' ) {
    //             headerScroll.cache.$body
    //                 .toggleClass('header-fixed', scrollY >= headerScroll.config.fixedHeader);
    //         }
    //     }
    // };
    // headerScroll.init();
    /******************** END SCROLL FUNCTIONS *******************/





    /****************************************************************/
    /**************************** SLIDERS ***************************/
    /****************************************************************/
    /* reference Slick Slider - https://kenwheeler.github.io/slick/ */

    const $hrlSlider    = $('.content-slider');
    const prevArrow     = '<span class="prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12.7071 7.29289C13.0976 7.68342 13.0976 8.31658 12.7071 8.70711L10.4142 11L16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13L10.4142 13L12.7071 15.2929C13.0976 15.6834 13.0976 16.3166 12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289Z" fill="#E1FD05"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" fill="#E1FD05"/></svg></span>';
    const nextArrow     = '<span class="next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12.7071 7.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071C10.9024 16.3166 10.9024 15.6834 11.2929 15.2929L13.5858 13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H13.5858L11.2929 8.70711C10.9024 8.31658 10.9024 7.68342 11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289Z" fill="#E1FD05"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" fill="#E1FD05"/></svg></span>';

    if( $hrlSlider.length ) {

        $hrlSlider.each( (_, el) => {

            // TESTIMONIALS BASIC SLIDER
            if( $(el).hasClass('testimonials-basic') ) {

                // initialize slide
                $(el).find('.hrl-slider-init').slick({
                    fade:           true,
                    speed:          500,
                    cssEase:        'ease-in-out',
                    arrows:         true,
                    autoplay:       true,
                    autoplaySpeed:  7000,
                    dots:           true,
                    infinite:       true,
                    prevArrow:      prevArrow,
                    nextArrow:      nextArrow
                });
            }


            // TESTIMONIALS BASIC SLIDER
            if( $(el).hasClass('hero-slider') ) {

                $(el).find('.hrl-slider-init').slick({
                    rows:           0,
                    fade:           true,
                    speed:          500,
                    cssEase:        'ease-in-out',
                    arrows:         false,
                    autoplay:       true,
                    autoplaySpeed:  5000,
                    pauseOnFocus:   false,
                    pauseOnHover:   false,
                    dots:           true,
                    infinite:       true,
                });

            }

        });
    }


    /************************** END SLIDERS *************************/


    /******************************************************************/
    /********************* NEWS & EVENTS FILTERING ********************/
    /******************************************************************/

    if( document.body.classList.contains('page-template-custom-news-events') ) {

        const filterDropdownToggle = document.getElementById('cat-dropdown-toggle');
        const catFilter = document.getElementById('cat-filter');
        const catFilterBtns = document.querySelectorAll('.cat-filter-btn');

        // Only bind dropdown toggle if elements exist
        if (filterDropdownToggle && catFilter) {
            filterDropdownToggle.addEventListener('click', function(event) {
                event.preventDefault();
                catFilter.classList.toggle('open');
            });
        }



        /**
         * ALM Filter button click event.
         *
         * @param {*} event
         */
        function filterClick(event) {
            event.preventDefault();

            const transition = 'fade';
            const speed = 250;

            // Show ALL if button active.
            if (this.classList.contains('active')) {
                this.classList.remove('active');

                var obj = {},
                count = 0;

                obj['post-type'] = 'post, event-cpt';
                obj['taxonomy'] = '';
                obj['taxonomy-terms'] = '';

                // Set filter params
                const data = obj;

                // Call core Ajax Load More `filter` function.
                // @see https://connekthq.com/plugins/ajax-load-more/docs/public-functions/#filter
                ajaxloadmore.filter(transition, speed, data);


            } else {
                // Change Filter

                // Get .active element.
                const activeEl = document.querySelector('.alm-filter-nav button.active');
                if (activeEl) {
                    activeEl.classList.remove('active');
                }

                // Add active class.
                this.classList.add('active');

                // Set filter params
                const data = this.dataset;

                const activePostType = data['postType'];
                const taxonomyOperator = data['taxonomyOperator'];
                // postFilter unused currently; keep if needed later
                const postFilter  = document.getElementById('post-filter');

                // Close Category Filter when a Term is selected
                if (catFilter) {
                    catFilterBtns.forEach(btn => {
                        btn.addEventListener('click', function(){
                            catFilter.classList.remove('open');
                        });
                    });
                }

                // Filter News & Insights
                const newsBtn = document.getElementById('gallery-btn');

                if (catFilter) {
                    if( activePostType === 'photo-gallery-cpt' ) {
                        catFilter.classList.remove('hide');
                        if (newsBtn) newsBtn.classList.add('active-type');
                    } else {
                        catFilter.classList.add('hide');
                        if (newsBtn) newsBtn.classList.remove('active-type');
                        catFilter.classList.remove('open');
                    }
                }

                // Call core Ajax Load More `filter` function.
                // @see https://connekthq.com/plugins/ajax-load-more/docs/public-functions/#filter
                ajaxloadmore.filter(transition, speed, data);

            }

        }

        // Get all filter buttons.
        const filter_buttons = document.querySelectorAll('.alm-filter-nav button:not(#cat-dropdown-toggle)');

        if (filter_buttons && filter_buttons.length) {
            function updateButtonWidths() {
                // match button widths
                let maxWidth = 0;

                // Find the maximum width among the buttons
                filter_buttons.forEach(function(button) {
                    var buttonWidth = button.offsetWidth;
                    if (buttonWidth > maxWidth) {
                        maxWidth = buttonWidth;
                    }
                });

                filter_buttons.forEach(function(button) {
                    button.style.minWidth = maxWidth + 'px';
                });
            }

            updateButtonWidths();

            window.addEventListener('resize', function() {
                filter_buttons.forEach(function(button) {
                    button.style.minWidth = '';
                });
                updateButtonWidths();
            });


            // Set initial active item.
            // filter_buttons[0].classList.add('active');

            // Loop buttons.
            [].forEach.call(filter_buttons, function (button) {
                button.addEventListener('click', filterClick);
            });
        }

        window.almComplete = function(alm){

        };

        // const params = new URLSearchParams(window.location.search);
        // const filter = params.get('filter');
        // const galleryBtn = document.getElementById('gallery-btn');

        // if( filter == 'galleries' && galleryBtn ) {
        //     setTimeout(() => {
        //         galleryBtn.click();
        //     }, 500);
        // }
    }





    /******************************************************************/
    /************************* HELPERS / FIXES ************************/
    /******************************************************************/

    // Prevent text widows on targetted elements
    //https://matmartin.co.uk/blog/code-prevent-widows-and-orphans-web-layouts/
    $('.no-orphans, .no-child-orphans p, .no-child-orphans a').each(function() {
        var string = $(this).html();
        string = string.replace(/ ([^ ]*)$/,'&nbsp;$1');
        $(this).html(string);
    });

    /*************************** END HELPERS ***************************/


    /***************************************************************************/
    /****************** KEEP THESE FUNCTIONS NEAR BOTTOM *****************/
    /***************************************************************************/


    // AOS (animate on scroll) INIT - https://michalsnik.github.io/aos/
    // (must call after any slick sliders to prevent conflicts)
    AOS.init({
        duration:   600,
        offset:     120,
    });

    // WINDOW RESIZER FUNCTIONS (create 'dbc_' debounced versions for use here)
    $(window).on('resize', function() {

        // check/set nav state (mobile/desktop)
        dbc_SetNavState();

    });

});
